import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-cms-dialog',
  templateUrl: './cms-dialog.component.html',
  styleUrls: ['./cms-dialog.component.scss'],
})
export class CmsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CmsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}
}

export interface DialogData {
  title: string;
  message: string;
  cancelLabel?: string;
  confirmLabel?: string;
}
